<div class="d-flex justify-content-start align-items-center dl-header">
  <div class="d-flex align-items-center dl-logo">
    <img routerLink="/home" routerLinkActive="active" class="dl-strykerlogo" src="assets/stryker-logo.jpg"
         alt="Stryker"/>
  </div>
  <div class="d-flex align-items-center dl-datalab-portal-title">
    DataLab
  </div>


  <div class="d-flex flex-row dl-user-profile-container ml-auto">

    <div class="d-flex flex-row dl-user-box align-items-center" [matMenuTriggerFor]="menu">
      <div class="d-flex flex-column justify-content-end" *ngIf="user$ | async as user">
        <div class="d-flex justify-content-start dl-header-user-label">{{user.title | default:'Logged In As'}}</div>
        <div class="d-flex justify-content-start dl-header-user-name" matTooltip="{{user.name}}"
             [matTooltipPosition]="'below'">
          <strong>{{user.name | truncate:20}}</strong>
        </div>
        <div class="d-flex justify-content-start dl-header-user-roles" *ngIf="user.roles?.length > 0">
          ({{user.roles.join(', ')}})
        </div>
      </div>
      <mat-icon aria-hidden="false" aria-label="expand" class="dl-menu-icon">
        expand_more
      </mat-icon>
    </div>

    <mat-menu #menu="matMenu">
      <a mat-menu-item id="btnHeaderAboutApp" class="btn btn-group-vertical dl-user-menu-item"
         routerLink="/app-info">
        About the Application
      </a>
      <a mat-menu-item id="btnHeaderTermsOfUse" class="btn btn-group-vertical dropdown-item dl-user-menu-item"
         routerLink="/terms-of-use">
        Terms Of Use
      </a>
      <a mat-menu-item id="btnConnectionInfo" class="btn btn-group-vertical dropdown-item dl-user-menu-item"
         href="https://teams.microsoft.com/l/entity/com.microsoft.teamspace.tab.wiki/tab::aeb51e33-a698-4017-ac78-fa2459b2c142?context=%7b%22subEntityId%22:%22%7b%5c%22pageId%5c%22:13%2c%5c%22sectionId%5c%22:16%2c%5c%22origin%5c%22:2%7d%22%2c%22channelId%22:%2219:CGKobPyRVuVXA4vht2Z_2rIueWXMIrn0e03vHHOjgCE1%40thread.tacv2%22%7d&tenantId=4e9dbbfb-394a-4583-8810-53f81f819e3b"
         target="_blank" rel="noopener">
        Connection Info
      </a>
      <a mat-menu-item id="btnHeaderUserLogout" class="btn btn-group-vertical dropdown-item dl-user-menu-item" (click)="logout()">
        Log Out
      </a>
    </mat-menu>
  </div>
</div>
